<template>
	<el-container class="list">
		<el-card>
			<div class="biaoq">
				<div class="biaoq_shu"></div>
				<div class="biaoq_title">个人中心</div>
			</div>
			<!-- 个人信息 -->
			<div class="userinfo">
				<img src="../../assets/img/f67d83fa274b9d0b392a3ca3f8a4ab9e.jpg" alt="">
				<div class="userinfo_right">
					<div class="userinfo_name">张三</div>
					<div class="userinfo_title">
						<span>部门权限</span>
						<span>项目经理</span>
					</div>
				</div>
			</div>
			<div class="biaoq">
				<div class="biaoq_shu"></div>
				<div class="biaoq_title">登录设置</div>
			</div>
			<div class="login_info">
				<div class="login_info_item">
					<div class="login_info_item_title">手机号</div>
					<div class="login_info_item_name">138****5566</div>
					<div class="login_info_item_btn" @click="goDetails('/changephone')">修改</div>
				</div>
				<div class="login_info_item">
					<div class="login_info_item_title">登录密码</div>
					<div class="login_info_item_name">********</div>
					<div class="login_info_item_btn" @click="goDetails('/changepsw')">修改密码</div>
				</div>
				<div class="login_info_item">
					<div class="login_info_item_title">第三方登录信息</div>
					<div class="login_info_item_name"></div>
					<div class="login_info_item_btn"></div>
				</div>
				<div class="login_info_item">
					<div class="login_info_item_title">微信账号</div>
					<div class="login_info_item_name">未绑定</div>
					<div class="login_info_item_btn" @click="goDetails('/wxqrcode')">立即绑定</div>
				</div>
			</div>
			<div class="biaoq">
				<div class="biaoq_shu"></div>
				<div class="biaoq_title">登录日志</div>
			</div>
			<el-table class="table-style" ref="tableSelection" :data="tableData" highlight-current-row width="100%"
				 border  :header-cell-style="{ background: '' }">
				<el-table-column :show-overflow-tooltip="true"  property="createDate" label="登录IP" align="center"/>
				<el-table-column :show-overflow-tooltip="true"  property="clientCode" label="登录地" align="center"/>
				<el-table-column :show-overflow-tooltip="true"  property="model" label="登录时间" align="center"/>
				<el-table-column :show-overflow-tooltip="true"  property="model" label="登录方式" align="center"/>
				<el-table-column :show-overflow-tooltip="true"  property="model" label="登录状态" align="center"/>
				<el-table-column :show-overflow-tooltip="true"  property="model" label="失败原因" align="center"/>
			</el-table>
			<div class="block" style="margin-top: 5px;text-align: center;">
			  <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
			    :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize"
			    layout="total, sizes, prev, pager, next, jumper" :total="total">
			  </el-pagination>
			</div>
		
			<!-- 添加或修改用户配置对话框 -->
			<el-dialog title="查看书刊" :visible.sync="open" width="500px" append-to-body>
			  <el-form ref="form" :model="form" :rules="rules" label-width="80px">
			        
			  </el-form>
			  <div slot="footer" class="dialog-footer">
			    <el-button @click="cancel">取 消</el-button>
				<el-button type="primary" @click="submitForm">确 定</el-button>
			  </div>
			</el-dialog>
		
		</el-card>
	</el-container>
</template>
<script>
	export default {
		data() {
			return {
				active:0,
				renw:[
					{id:0,title:'全部'},
					{id:1,title:'写手'},
					{id:2,title:'设计'},
					],
				selist:[{value:'',label:'全部'},{value:1,label:'是'},{value:0,label:'否'}],
				loading: false,
				tableData: [{}],
				pageSizes: [10, 50, 100, 200],
				pageSize: 10,
				total: 0,
				currentPage: 1,
				queryParams: {
				  pageNum: 1,
				  pageSize: 10,
				},
				// 表单校验
				rules: {},
				open:false,
				form:{},
			};
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			addteam(){
				this.open = true
			},
			submitForm(){
				this.open = false
			},
			cancel(){
				this.open = false
			},
			//跳转
			goDetails(url){
				// console.log(row)
				// if (row.priceUpdateDate !== null) {
				//   row.priceUpdateDate = this.$moment(new Date()).format("YYYY-MM-DD");
				// }
				this.$router.push({
				  path: url,
				  query: {
				    id: "1",
				  },
				});
			},
			xuan(id){
				if(this.active != id){
					this.active = id
				}
			},
			/** 搜索按钮操作 */
			handleQuery() {
			  this.queryParams.pageNum = 1;
			  
			},
			/** 重置按钮操作 */
			resetQuery() {
			  this.resetForm("queryForm");
			  this.handleQuery();
			},
			// 分页
			handleSizeChange(pageSize) {
				this.pageSize = pageSize;
				this.currentPage = 1;
				this.getTableData(this.queryCondition, this.currentPage, this.pageSize);
			},
			handleCurrentChange(currentPage) {
				this.currentPage = currentPage;
				this.getTableData(this.queryCondition, this.currentPage, this.pageSize);
			}
		},
	};
</script>
<style lang="less" scoped>
	.userinfo{
		width: 100%;
		display: flex;
		box-sizing: border-box;
		padding-bottom:40px;
		border-bottom: 1px solid #E6E6E6;
		img{
			width: 120px;
			height: 120px;
			border-radius: 10px;
			object-fit: cover;
		}
		.userinfo_right{
			margin-left: 40px;
			.userinfo_name{
				font-size: 24px;
				color: #333333;
				line-height: 24px;
				padding-top: 10px;
			}
			.userinfo_title{
				font-size: 18px;
				color: #333333;
				line-height: 18px;
				margin-top: 35px;
				span{
					margin-right: 40px;
				}
			}
		}
	}
	.login_info{
		width: 100%;
		box-sizing: border-box;
		padding-left: 22px;
		.login_info_item{
			width: 100%;
			display: flex;
			align-items: center;
			font-size: 18px;
			line-height: 18px;
			margin-bottom: 45px;
			.login_info_item_title{
				color: #676767;
				width: 130px;
			}
			.login_info_item_name{
				color: #333333;
				margin-left: 45px;
			}
			.login_info_item_btn{
				color: #4076F3;
				margin-left: auto;
				cursor: pointer;
			}
		}
	}
	
	
	.dialog-footer {
		text-align: center;
	}

	/deep/.el-form-item__error {
		margin-left: 70px;
	}

	// 取消表格全选框
	/deep/ .el-table__header-wrapper .el-checkbox {
		display: none;
	}

	.el-card {
		// min-width: 1480.49px;
	}
</style>



// WEBPACK FOOTER //
// src/components/user/index.vue